const mock_data = {
    "list_gifts": { "44648296644815": [44569171525839], "44875993776335": [44569171525839] },
    "free_gifts": {
        "44569171525839": {
            "variant_id": 44569171525839,
            "gifts": [{
                "gift_id": "44875993776335"
            }, {
                "gift_id": "44648296644815"
            }]
        }
    }
}

function getBundleGifts(_list_gifts) {
    return _list_gifts.reduce((total, gift) => total + gift.original_line_price, 0);
}

function validateGift(gifts_in_cart, schema) {
    const amount_total = getBundleGifts(gifts_in_cart);
    return schema.combo.some(combo => {
        const isValidCombo = amount_total % combo.total === 0;
        return isValidCombo;
    });
}
function getAllowGiftsWith(products) {
    const free_gifts = window.free_gifts || {};
    let result = {};
    products.forEach(product => {
        let quantity_product = product.quantity;
        let gifts_available = free_gifts[product.variant_id]?.gifts || null;
        if (gifts_available) {
            gifts_available.forEach(gift => {
                if (!result[gift.gift_id]) {
                    result[gift.gift_id] = quantity_product;
                    return;
                }
                result[gift.gift_id] += quantity_product;
            })
        }
    });
    return result;
}
async function updateCartEndpoint(items) {
    return await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: items })
    })
        .then(response => {
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}
const extractGiftsFromCart = (cart_items, _gifts) => {
    let result = cart_items.filter(item => _gifts.hasOwnProperty(item.variant_id))
    // merge same variant_id
    result = result.reduce((acc, item) => {
        if (!acc[item.variant_id]) {
            acc[item.variant_id] = item;
        } else {
            acc[item.variant_id].quantity += item.quantity;
        }
        return acc;
    }, {});

    // convert to array
    result = Object.values(result);

    return result;
}
document.addEventListener("DOMContentLoaded", function () {
    let time_now = new Date().getTime();
    let expired_time = new Date('2026-04-23').getTime();
    if (time_now > expired_time) {
        console.log("Validate gifts script expired");
        return;
    }
    let list_gifts = window.list_gifts || {};

    if (Object.keys(list_gifts).length === 0) {
        return;
    }

    const schema_validate_gifts = {
        "combo": [
            { "key": "combo_gifts_1", "total": 20400000, "quantity": 2 },
            { "key": "combo_gifts_2", "total": 35100000, "quantity": 2 },
            { "key": "combo_gifts_3", "total": 44400000, "quantity": 2 },
        ]
    }

    // cart change event listener
    document.addEventListener("cart:change", function (event) {
        // get list gifts from cart

        let gifts_in_cart = extractGiftsFromCart(event.detail.cart.items, list_gifts);

        const isAllow = validateGift(gifts_in_cart, schema_validate_gifts);
        if (!isAllow) {
            // get list product else gifts
            let products_in_cart = event.detail.cart.items.filter(item => !list_gifts.hasOwnProperty(item.variant_id));
            let list_gift_in_cart = event.detail.cart.items.filter(item => list_gifts.hasOwnProperty(item.variant_id));

            // get allow gifts with products            
            let allow_gifts_with_product = getAllowGiftsWith(products_in_cart);

            let exist_gitfs_in_cart_quantity = {};
            gifts_in_cart.forEach(gift_item => {
                exist_gitfs_in_cart_quantity[gift_item.variant_id] = gift_item.quantity;
            });

            // extract not allow gifts
            let gifts_to_remove = [];
            list_gift_in_cart.forEach(gift_item => {
                let allowed_quantity = allow_gifts_with_product[gift_item.variant_id] || 0;
                let exist_quantity = exist_gitfs_in_cart_quantity[gift_item.variant_id] || 0;
                if (exist_quantity > allowed_quantity) {
                    let quantity_to_remove = exist_quantity - allowed_quantity;
                    gifts_to_remove.push({
                        id: gift_item.variant_id,
                        quantity: quantity_to_remove,
                        target_quantity: allowed_quantity
                    });
                }
            });

            if (gifts_to_remove.length === 0) {
                return;
            }

            // extract items in cart to update
            let items_to_update = {};
            event.detail.cart.items.map(item => {
                items_to_update[item.variant_id] = item.quantity;
            })
            gifts_to_remove.forEach(gift_remove => {
                let variant_id = event.detail.cart.items.find(item => item.variant_id === gift_remove.id).variant_id;
                items_to_update[variant_id] = gift_remove.target_quantity;
            });

            // update cart
            updateCartEndpoint(items_to_update).finally(() => {
                document.dispatchEvent(new CustomEvent("cart:refresh"));
            }).catch(error => {
                console.error('Error:', error);
            });

        }
    });
});